import React from 'react';
import {
  Box,
  Typography,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@mui/material';
import StandardizedChip from '../../common/StandardizedChip';

/**
 * PolicyRulesTab Component
 *
 * Displays policy rules in a table format.
 *
 * @param {Object} props
 * @param {Array} props.rules - Array of policy rules
 * @param {boolean} props.loading - Whether rules are loading
 */
function PolicyRulesTab({ rules, loading }) {
  if (loading) {
    return <Alert severity="info">Loading rules...</Alert>;
  }

  if (!rules || rules.length === 0) {
    return <Alert severity="info">No rules available for this policy</Alert>;
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Policy Rules
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Rule Name</TableCell>
              <TableCell>Data Type</TableCell>
              <TableCell>Sensitivity</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rules.map((rule, index) => (
              <TableRow key={index}>
                <TableCell>{rule.name}</TableCell>
                <TableCell>
                  <StandardizedChip label={rule.data_type} width={110} />
                </TableCell>
                <TableCell>
                  <StandardizedChip
                    label={rule.sensitivity_level}
                    color={
                      rule.sensitivity_level === 'restricted'
                        ? 'error'
                        : rule.sensitivity_level === 'confidential'
                          ? 'warning'
                          : 'default'
                    }
                    width={110}
                  />
                </TableCell>
                <TableCell>{rule.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default PolicyRulesTab;
